<template>
  <v-navigation-drawer
    clipped
    app
    :expand-on-hover="true"
    :hide-overlay="true"
    dark
    :miniVariant="true"
    :right="true"
  >
    <v-list dense nav>
      <template v-for="(item, i) in menuItems">
        <navbar-group v-if="item.group" :key="`group-${i}`" :item="item" />
        <navbar-item
          v-else
          :key="`item-${i}`"
          :icon="item.icon"
          :subtext="item.subtext"
          :text="item.text"
          :to="item.to"
        />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import items from '@/data/menu';

export default {
  data: () => ({
    items,
  }),
  props: {
    menuType: String,
  },
  computed: {
    ...mapState('app', ['sideBarMini']),
    ...mapGetters(['filteredMenu']),
    menuItems() {
      return this.filteredMenu(items[this.menuType]);
    },
  },
};
</script>

<style></style>
